module.exports = __webpack_public_path__ + "img/teaching_class.ce5ea513.jpeg";